import styled from 'styled-components';

import { Div, FlexGrow, H1, P } from 'common/styles/oc-styled-components';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';

export const InlineBlock = styled(Div)`
  display: inline-block;
  vertical-align: top;
`;

export const MostHelpfulReview = styled(FlexGrow)`
  font-size: 16px;
  position: relative;
  text-align: left;
`;

// TODO truncate with ellipsis
export const MostHelpfulReviewText = styled(P)`
  --lh: 1.5em;

  font-weight: 400;
  color: ${colors.slate};
  line-height: var(--lh);
  max-height: calc(var(--lh) * 4);
  overflow: hidden;
`;

export const ProfileName = styled(H1)`
  color: ${colors.charcoal};
  font-size: 35px;
  font-weight: 600;

  @media (max-width: ${BREAKPOINTS.tabletMax}px) {
    font-size: 30px;
  }
`;

export const AddressLine = styled(Div)`
  color: ${colors.charcoal};
  font-size: 22px;
`;
